import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import * as superagent from 'superagent';
import { companyInfo } from 'src/api';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { message } from 'antd';
import { Urls } from 'kts-platform-frame/entry/constant';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';  

class ModulesAction extends ActionBasic<ModulesState> {
    public getCompanyInfo = async (call?: Function) => {
        const res = await companyInfo.companyInfo(this);
        if (res.er) {
            return;
        }

        const body = res.res;
        this.modulesState.companyInfo = body;
        this.modulesState.openingBankInfos = body.openingBankInfos || [];
        if (body.location.country) {
            await this.countryInfo();
            const countries = this.modulesState.countryInfo;
            const thisCountry = countries.filter(el => {
                return el.name === body.location.country;
            });
            await this.countryStates({
                countryCode: thisCountry[0].code
            });
            if (body.location.state) {
                const states = this.modulesState.countryStates;
                const thisStates = states.filter(el => {
                    return el.name === body.location.state;
                });
                this.countryStateCities({
                    stateCode: thisStates[0].code
                });
            }
        }
        if (call) {
            call();
        }
        this.setModulesState(this.modulesState);
    }

    public updateEditStatu = (w: string, b: boolean) => {
        this.modulesState[w] = b;
        this.setModulesState(this.modulesState);
    }

    public detailUpdate = async (options, call?: Function) => {
        const res = await companyInfo.detailUpdate(this, options);
        if (res.er) {
            return;
        }

        const user = MyStore.instance.getState().user;
        user.userInfo.companyName = res.res.companyName;
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user);

        // 调用回掉函数
        if (call) {
            this.getCompanyInfo(call);
        } else {
            this.getCompanyInfo();
        }
    }

    public bankUpdate = async (options) => {
        let extOpeningBankInfo = this.modulesState.openingBankInfos.map((item) => {
            return {
                bankCode: options.bankCode,
                bankId: item.bankId,
                isDefault: false,
                openingBank: item.openingBank
            };
        });
        const res = await companyInfo.bankUpdate(this, {...options, extOpeningBankInfo});
        if (!res.er) {
            this.getCompanyInfo();
        }
    }

    public descriptionUpdate = async (options) => {
        const res = await companyInfo.descUpdate(this, options);
        if (!res.er) {
            this.getCompanyInfo();
        }
    }

    public uploadToken = async (options) => {
        const res = await companyInfo.uploadToken(this);
        if (!res.er) {
            this.modulesState.uploadTokenData = res.res;
        }
        this.setModulesState(this.modulesState);
    }

    public imageUpdate = async (options) => {
        const res = await companyInfo.imageUpdate(this, options);
        if (!res.er) {
            this.getCompanyInfo();
        }
    }

    public countryInfo = async (options?: any) => {
        const res = await companyInfo.countryInfo(this, options);
        if (!res.er) {
            this.modulesState.countryInfo = res.res;
            this.setModulesState(this.modulesState);
        }
    }

    public countryStateCities = async (options?: any) => {
        if (options) {
            const res = await companyInfo.countryStateCities(this, options);
            this.modulesState.countryStateCities = res.res;
        } else {
            this.modulesState.countryStateCities = [];
        }
        this.setModulesState(this.modulesState);
    }

    public countryStates = async (options?: any) => {
        const res = await companyInfo.countryStates(this, options);
        this.modulesState.countryStates = res.res;
        this.setModulesState(this.modulesState);
    }

    public updatePercent = (data) => {
        this.modulesState.updateLogPercent = data;
        this.setModulesState();
    }

    public updateLogPercentView = (data) => {
        this.modulesState.updateLogPercentView = data;
        this.setModulesState();
    }

    public updateSnapCountry = (country) => {
        this.modulesState.snapCountry = country;
        this.setModulesState();
    }

    public updateSnapState = (state) => {
        this.modulesState.snapState = state;
        this.setModulesState();
    }

    public updateSnapCity = (city) => {
        this.modulesState.snapStateCity = city;
        this.setModulesState();
    }

    public setupDefaultLocation = () => {
        const { country, state, city } = this.modulesState.companyInfo.location;
        this.modulesState.snapCountry = country;
        this.modulesState.snapState = state;
        this.modulesState.snapStateCity = city;
        this.setModulesState();
    }

    public updateDescription = msg => {
        this.modulesState.description = msg;
        this.setModulesState();
    }

    public changeUpdateKey = (val) => {
        this.modulesState.activeKey = val;
        this.setModulesState();
    }
    // 获取公司风采图
    public elegantImagesGet = async () => {
        const res: any = await companyInfo.elegantImagesGet(this);
        if (res.er) {
            return;
        }
        this.modulesState.imgList = res.res;
        this.setModulesState();
    }
    // 公司风采图片 上传
    public eleganceImgUpload = async (file) => {
        // 获取 token
        const getSimpleToken: any = await companyInfo.uploadToken(null);

        if (getSimpleToken.er) {
            return null;
        }
        
        const { user } = MyStore.instance.getState(); 
        // console.log('111111', user);
        // 上传到7niu
        const upload = await superagent.post(`//${getSimpleToken.res.uploadUrl}`).set({Authorization: user.cToken})
            .field('key', getSimpleToken.res.keyPrefix)
            // .field('token', getSimpleToken.res.token) 
            .attach('file', file); 
        if (!upload.body.ok) {
            message.error('上传失败，请重试');
            return null;
        }
        const uploadKey = upload.body.body&&upload.body.body.key;
        if (!uploadKey){
            return;
        }

        // key上传文件到后台
        const uploadSend: any = await companyInfo.elegantImagesUpload(null,{
            key: uploadKey
        });

        if (uploadSend.er || !uploadSend.res) {
            return null;
        }
        
        this.modulesState.imgList = Array.isArray(uploadSend.res) ? uploadSend.res : [];
        this.setModulesState();
    }
    // 删除
    public eleganceImgDelete = async (id) => {
        const res: any = await companyInfo.elegantImagesDelete(this,{
            imageId: id
        });
        if (res.er) {
            return;
        }
        this.modulesState.imgList = Array.isArray(res.res) ? res.res : [];
        this.setModulesState();
    }
    // 设置 主图
    public elegantSetMainImage = async (id) => {
        const res: any = await companyInfo.elegantSetMainImage(this, {
            imageId: id
        });
        if (res.er) {
            return;
        }
        this.modulesState.imgList = Array.isArray(res.res) ? res.res : [];
        this.setModulesState();
    }
    // 展示公司风采 弹框
    public showEleganceModal = (isShow: boolean, src?: string) => {
        this.modulesState.showEleganceModal = isShow;
        this.modulesState.imgUrlElegance = src;
        this.setModulesState();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Modules.Action.ts